import { app, auth, analytics, emulatorConfig } from './firebaseApp.js';
import { getDb, registerDb, listRegisteredDbs } from './firestoreRegistry.js';

if (typeof process !== 'undefined' && process?.env?.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(
    '[firebaseConfig] is deprecated. Import from firebaseApp.js or firestoreRegistry.js instead.',
  );
}

export { app, auth, analytics, emulatorConfig };

registerDb({ name: 'moments', databaseId: 'moments-db-og' });
registerDb({ name: 'moments-db-og', databaseId: 'moments-db-og' });

export const momentsDb = getDb('moments');
export const db = momentsDb;

export { getDb, registerDb, listRegisteredDbs };
